export default "__VITE_ASSET__DYNmGiwE__"